<template>
  <div class="menu-picture" @click="showOptions">
    <div v-if="user && showImage" id="photo-header-user" :style="'background: #' + picColor">
      <!-- IF pas de photo chargée -> Form permet de charger la photo de profil -->
      <img :src="picUrl" alt="Photo de profil" width="48" height="48"/>

      <div class="menu-picture-wrapper">
        <div v-show="showMenu" class="options-profile">
          <div class="add-profile-picture-text" v-if="!user.avatar.approved">Photo en cours de validation</div>

          <label for="form-profil-photo-user">Modifier la photo</label>
          <input type="file" id="form-profil-photo-user" @change="uploadImage" accept="image/*">

          <router-link :to="{ name: 'DashboardAccountEdition' }" @click="showMenu = false"
                       title="Modifier le profil à votre compte COOLOC">
            Modifier le profil
          </router-link>

          <router-link to="/signout"
                       title="Se déconnecter">
            Se déconnecter
          </router-link>
        </div>
      </div>
    </div>

    <div v-else id="photo-header-user">
      <div class="photo-wrapper">
        <div class="photo-initials">{{ user && user.first_name && user.name ? user.first_name.substring(0, 1) + user.name.substring(0, 1) : '' }}</div>
      </div>

      <div class="menu-picture-wrapper">
        <div v-show="showMenu" class="options-profile">
          <label for="form-profil-photo-user">Ajouter une photo</label>
          <input type="file" id="form-profil-photo-user" @change="uploadImage" accept="image/*">

          <router-link :to="{ name: 'DashboardAccountEdition' }" @click="showMenu = false"
                 title="Modifier le profil à votre compte COOLOC">
            Modifier le profil
          </router-link>

          <router-link to="/signout"
                       title="Se déconnecter">
            Se déconnecter
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus, registrationHelpers } from '@/main'
import imageUpload from '@/components/mixins/imageUpload'

export default {
  name: 'profile-picture',
  mixins: [imageUpload],
  props: {
    uploadOnClick: Boolean,
  },
  data() {
    return {
      popupInfo: {
        id: 'popup-info-profile-picture',
        title: '',
        content: '',
        link: '',
        linktitle: '',
      },
      popupError: {
        id: 'popup-error-profile-picture',
        title: '',
        content: '',
        link: '',
        linktitle: '',
      },
      showMenu: false,
      user: {
        id: 0,
        avatar: {},
        profile: {
          position: '',
        },
      },
    }
  },
  computed: {
    showImage() {
      return this.user.avatar && this.user.avatar.id && this.user.avatar.id.replace(/[0-]/g, '') !== ''
    },
    picUrl() {
      return `/image/${this.user.avatar.id}/360/360`
    },
    picColor() {
      if (this.user.avatar.approved) {
        return (0x1000000 | this.user.avatar.color).toString(16).substring(1)
      }
      return 'FFF'
    },
  },
  methods: {
    uploadImage() {
      const fileInput = document.getElementById('form-profil-photo-user')
      const file = fileInput.files[0]
      if (this.validateImage(file)) {
        this.parseImage(file).then(form => {
          return this.$http.post('/api/users/upload', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
        }).then(resp => {
          this.$router.go(this.$router.currentRoute)
        }).catch(error => {
          this.submitError = true
          registrationHelpers.show(this, { title: "Erreur l'image est invalide", text: `La taille de l'image doit être inférieure à ${this.max_image_weight} Mo ou n'a pas le bon format.` }, 'popup-info-profile-picture')
          this.errorMessage = error.response ? error.response.data : error.message
          setTimeout(function () {
            this.submitting = false
            //
          }, 2000)
        }).finally(() => this.showMenu = false)
      } else {
        registrationHelpers.show(this, { title: "Erreur l'image est invalide", text: `La taille de l'image doit être inférieure à ${this.max_image_weight} Mo ou n'a pas le bon format.` }, 'popup-info-profile-picture')
      }
    },
    showOptions() {
      this.showMenu = !this.showMenu
    },
    closeMenu(e) {
      if (!this.$el.contains(e.target)) {
        this.showMenu = false
      }
    },
  },
  created() {
    eventBus.$on('userChanged', data => this.user = data)
  },
  mounted() {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu)
  },
}

</script>

<style lang="scss">
.link-edit-profile {
  background: transparent !important;
  border: none !important;
  color: $red !important;
  a {
    color: $red !important;
  }

  @media #{$phone} {
    display: none;
  }
}

.link-edit-profile.profile-saving {
  display: none;
  body.profile-saving & {
    display: block;
  }
}
</style>
